import React, { FunctionComponent } from 'react'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'

export const EditorFormDividerField: FunctionComponent = () => (
  <Box paddingY={4}>
    <Divider className="editor-form__divider" />
  </Box>
)
